import Cancellable from "./Cancellable";

export default class CancellableQueue implements Cancellable {
	private readonly queue: Cancellable[] = [];
	private active = true;

	public isActive(): boolean {
		return this.active;
	}

	public enqueue(item: Cancellable) {
		if (this.isActive()) {
			this.queue.push(item);
		} else {
			item.cancel();
		}
	}

	/**
	 * Alias for cancel to make integrations with ComponentManager easier
	 */
	public destroy() {
		this.cancel();
	}
	public cancel() {
		if (this.isActive()) {
			this.active = false;
			this.queue.forEach(item => {
				item.cancel();
			});
		}
	}
}
